import { Mutate, StoreApi, UseBoundStore } from 'zustand';

import { JobPosition } from '@pflegia/types/api/job-position/job-position';
import { SourceDomain } from '@pflegia/types/api/source-domain/source-domain';
import { FunnelState, useFunnelState as useFunnelStateLib } from '@pflegia/ui/funnel/hooks/use-funnel-state';
import { FunnelAnswers } from '@pflegia/ui/pflegia/funnel/types/funnel-answers';

export const useFunnelState = useFunnelStateLib as UseBoundStore<Mutate<StoreApi<FunnelState<FunnelAnswers>>, []>>;

export type FunnelProps = { jobPosition: JobPosition; sourceDomain: SourceDomain };
